import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Label, Input } from 'reactstrap'

const Select = props => {
  return (
    <FormGroup>
      <Label for={props.name}>
        {props.label}{' '}
        {props.enableShowRequired && props.showRequired && (
          <span style={{ color: '#B8002F' }}>Required</span>
        )}
      </Label>
      <Input
        disabled={!props.data || props.disabled}
        id={props.name}
        name={props.name}
        onBlur={props.onBlur}
        onChange={props.onChange}
        required={props.required}
        type="select"
        value={props.value}
      >
        <option key="blank" value="blank" />
        {props.data &&
          (props.renderOptions
            ? props.renderOptions(props.data)
            : props.data.map(val => <option key={val}>{val}</option>))}
      </Input>
      {
        props.warning && <span>{props.warning}</span>
      }
    </FormGroup>
  )
}

Select.propTypes = {
  enableShowRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.array,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  warning: PropTypes.string,
  renderOptions: PropTypes.func,
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Select.js